var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.24609C9 6.04174 9.31607 6.80481 9.87868 7.36741C10.4413 7.93002 11.2044 8.24609 12 8.24609C12.7956 8.24609 13.5587 7.93002 14.1213 7.36741C14.6839 6.80481 15 6.04174 15 5.24609C15 4.45044 14.6839 3.68738 14.1213 3.12477C13.5587 2.56216 12.7956 2.24609 12 2.24609C11.2044 2.24609 10.4413 2.56216 9.87868 3.12477C9.31607 3.68738 9 4.45044 9 5.24609V5.24609Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 18.7461C0.75 19.5417 1.06607 20.3048 1.62868 20.8674C2.19129 21.43 2.95435 21.7461 3.75 21.7461C4.54565 21.7461 5.30871 21.43 5.87132 20.8674C6.43393 20.3048 6.75 19.5417 6.75 18.7461C6.75 17.9504 6.43393 17.1874 5.87132 16.6248C5.30871 16.0622 4.54565 15.7461 3.75 15.7461C2.95435 15.7461 2.19129 16.0622 1.62868 16.6248C1.06607 17.1874 0.75 17.9504 0.75 18.7461V18.7461Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18.7461C17.25 19.5417 17.5661 20.3048 18.1287 20.8674C18.6913 21.43 19.4544 21.7461 20.25 21.7461C21.0456 21.7461 21.8087 21.43 22.3713 20.8674C22.9339 20.3048 23.25 19.5417 23.25 18.7461C23.25 17.9504 22.9339 17.1874 22.3713 16.6248C21.8087 16.0622 21.0456 15.7461 20.25 15.7461C19.4544 15.7461 18.6913 16.0622 18.1287 16.6248C17.5661 17.1874 17.25 17.9504 17.25 18.7461V18.7461Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.7461H17.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6592 7.74609L18.9412 16.0461",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3411 7.74609L5.05908 16.0461",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b3e40589.svg";
export { ForwardRef as ReactComponent };